export var CSRF_TOKEN_ID = "anti-csrftoken-a2z";

//# sourceMappingURL=index.js.map